


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBR-XHt2RTaP7zoUZCxACP4a3jIvP3rvq0",
  authDomain: "vision-infinity-df462.firebaseapp.com",
  projectId: "vision-infinity-df462",
  storageBucket: "vision-infinity-df462.firebasestorage.app",
  messagingSenderId: "917397863745",
  appId: "1:917397863745:web:7d38ecc7c28ea5b165f5c0"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export